import { useEffect, useRef, useState } from "react";

const useSpeechSynthesis = () => {
    const [voices, setVoices] = useState([]);
    const [speaking, setSpeaking] = useState(false);
    const synth = useRef();
    
    const updateVoices = () => {
        setVoices(synth.current.getVoices());
    };
    
    const speak = (text, voice, pitch = 1, rate = 1) => {
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.voice = voice;
        utterance.pitch = pitch;
        utterance.rate = rate;

        utterance.onstart = () => {
            setSpeaking(true);
        };

        utterance.onend = () => {
            setSpeaking(false);
        };

        synth.current.speak(utterance);
    }
    
    useEffect(() => {
        if (typeof window !== 'object' || !window.speechSynthesis) return;
        synth.current = window.speechSynthesis;
        synth.current.onvoiceschanged = updateVoices;
        updateVoices();
        
        return () => {
        synth.current.onvoiceschanged = null
        }
    }, []);
    
    return ([
        voices,
        speak,
        speaking
    ]);
}

export default useSpeechSynthesis;